export const DOCUMENT_DASHBOARD = {
    USAGE_TREND_CHART_TITLE:{key:'USAGE_TREND_CHART_TITLE',value:'Usage Trend'},
    SYSTEM_SPEED_CHART_TITLE:{key:'SYSTEM_SPEED_CHART_TITLE',value:'System Speed'},
    DOCUMENT_GENERATION_STABILITY_CHART_TITLE:{key:'DOCUMENT_GENERATION_STABILITY_CHART_TITLE',value:'Document Generation Stability'},
    USER_EXPIRENCE_METRICS_CHART_TITLE:{key:'USER_EXPIRENCE_METRICS_CHART_TITLE',value:'User Experience Metrics'},
    USAGE_TREND_CHART_DESCRIPTION:{ key:'USAGE_TREND_CHART_DESCRIPTION',value:'Average documents generated'},
    SYSTEM_SPEED_CHART_DESCRIPTION:{key:'SYSTEM_SPEED_CHART_DESCRIPTION',value:'Average time taken to generate document'},
    DOCUMENT_GENERATION_STABILITY_CHART_DESCRIPTION:{key:'DOCUMENT_GENERATION_STABILITY_CHART_DESCRIPTION',value:'Failure rate over a period of one year'},
    USER_EXPIRENCE_METRICS_CHART_DESCRIPTION: { key: 'USER_EXPIRENCE_METRICS_CHART_DESCRIPTION', value: 'Average time spent on designing templates' },
    DOCUMENT_DASHBOARD_TITLE:{key:'DOCUMENT_DASHBOARD_TITLE',value:'Only the best insights : Documents'},
    INSIGHTS_FAILURE_REASON_SECTION_TITLE:{key:'INSIGHTS_FAILURE_REASON_SECTION_TITLE',value:'Failure Reasons'},
    VIEW_FAILED_TRANSACTIONS_ACTION:{key:'VIEW_FAILED_TRANSACTIONS_ACTION',value:'View'},
    ALL_TEMPLATE_CATEGORY_DROPDOWN_OPTION:{key:'ALL_TEMPLATE_CATEGORY_DROPDOWN_OPTION',value:'All'},
    PUBLISHED_TAB_TITLE:{key:'PUBLISHED_TAB_TITLE',value:'Published'},
    TESTING_TAB_TITLE:{key:'TESTING_TAB_TITLE',value:'Testing'},
    TOTAL_DOCUMENT_GENERATED_STATS_LABEL:{key:'TOTAL_DOCUMENT_GENERATED_STATS_LABEL',value:'Total Documents Generated'},
    INQUEUE_STATS_LABEL:{key:'INQUEUE_STATS_LABEL',value:'Inqueue'},
    FAILURE_STATS_LABEL: { key: 'FAILURE_STATS_LABEL', value: 'Failure Stats' },
    FAILURE_REASONS_INVALID_DATA_CARD_TITLE:{key:'FAILURE_REASONS_INVALID_DATA_CARD_TITLE',value:'Invalid Data'},
    FAILURE_REASONS_UNKNOWN_CARD_TITLE:{key:'FAILURE_REASONS_UNKNOWN_CARD_TITLE',value:'Unknown'},
    VIEW_TEMPLATES_PRONE_TO_FAILURE_ACTION:{key:'VIEW_TEMPLATES_PRONE_TO_FAILURE_ACTION',value:'View top 10 templates prone to failure'},
    VIEW_TEMPLATES_TAKING_MORE_TIME_TO_DESIGN_ACTION: { key: 'VIEW_TEMPLATES_TAKING_MORE_TIME_TO_DESIGN_ACTION', value: 'View top 10 templates takes more time with designing' },
    TEMPLATES_PRONE_TO_FAILURE_LIST_TITLE:{key:'TEMPLATES_PRONE_TO_FAILURE_LIST_TITLE',value:'Top 10 Templates Prone to Failure'},
    DRAFT_TAB_TITLE: { key: 'DRAFT_TAB_TITLE', value: 'Draft' }
}

export const FAILURE_DOCUMENT_TEMPLATE_DETAILS_MODAL = {
    FAILURE_DOCUMENT_TEMPLATE_DETAILS_MODAL_TITLE:{key:'FAILURE_DOCUMENT_TEMPLATE_DETAILS_MODAL_TITLE',value:'Failure Details'},
    FAILURE_DETAILS_HEADING:{key:'FAILURE_DETAILS_HEADING',value:'Payload'},
    RUNTIME_ERROR_MESSAGE:{key:'RUNTIME_ERROR_MESSAGE',value:'Runtime Error'},
    NO_DETAILS_AVAILABLE_LABEL: { key: 'NO_DETAILS_AVAILABLE_LABEL', value: 'No details available.' },
}

export const FAILED_DOCUMENT_TEMPLATE_TRANSACTIONS_TABLE = {
    FAILED_DOCUMENT_TEMPLATE_TRANSACTIONS_TABLE_TITLE:{key:'FAILED_DOCUMENT_TEMPLATE_TRANSACTIONS_TABLE_TITLE',value:'List of Failed Transactions'},
    REQUESTED_TIME_COLUMN_TITLE:{key:'REQUESTED_TIME_COLUMN_TITLE',value:'Requested Time'},
    PROCESS_INITIATED_FROM_COLUMN_TITLE:{key:'PROCESS_INITIATED_FROM_COLUMN_TITLE',value:'Process Initiated From'},
    TEMPLATE_COLUMN_TITLE:{key:'TEMPLATE_COLUMN_TITLE',value:'Template'},
    FAILURE_REASONS_COLUMN_TITLE:{key:'FAILURE_REASONS_COLUMN_TITLE',value:'Failure Reason'},
    FAILURE_DETAILS_COLUMN_TITLE:{key:'FAILURE_DETAILS_COLUMN_TITLE',value:'Failure Details'},
    FAILURE_TIME_COLUMN_TITLE:{key:'FAILURE_TIME_COLUMN_TITLE',value:'Failure Time'},
    TEAM_NAME_COLUMN_LABLE: { key: 'TEAM_NAME_COLUMN_LABLE', value: 'Team Name' },
    VIEW_FAILURE_DETAILS_ACTION:{key:'VIEW_FAILURE_DETAILS_ACTION',value:'View details'}, 
    FAILURE_REASONS_INVALID_DATA_DROPDOWN_OPTION_LABLE:{key:'FAILURE_REASONS_INVALID_DATA_DROPDOWN_OPTION_LABLE',value:'Invalid Data'},
    FAILURE_REASONS_UNKNOWN_DROPDOWN_OPTION_LABLE:{key:'FAILURE_REASONS_UNKNOWN_DROPDOWN_OPTION_LABLE',value:'Unknown'},
    LANGUAGE_COLUMN_TITLE: { key: 'LANGUAGE_COLUMN_TITLE', value: 'Language' },
};

export const TOP_TEN_TEMPLATES_TABLE = {
    TEMPLATE_NAME_COLUMN_TITLE:{key:'TEMPLATE_NAME_COLUMN_TITLE',value:'Template Name'},
    FAILURES_COUNT_COLUMN_TITLE:{key:'FAILURES_COUNT_COLUMN_TITLE',value:'No Of Failures'},
    NO_DATA_TEXT: { key: 'NO_DATA_TEXT', value: 'No Data' },
}

export const EMAIL_DASHBOARD = {
    USAGE_TREND_CHART_TITLE:{key:'USAGE_TREND_CHART_TITLE',value:'Usage Trend'},
    EMAIL_PERFORMANCE_CHART_TITLE:{key:'EMAIL_PERFORMANCE_CHART_TITLE',value:'Email Performance'},
    EMAIL_STABILITY_CHART_TITLE:{key:'EMAIL_STABILITY_CHART_TITLE',value:'Emailing Stability'},
    USAGE_TREND_CHART_DESCRIPTION:{key:'USAGE_TREND_CHART_DESCRIPTION',value:'Average number of emails sent vs delivered'},
    EMAIL_PERFORMANCE_CHART_DESCRIPTION:{key:'EMAIL_PERFORMANCE_CHART_DESCRIPTION',value:'Open rate and click rates over a period of one year'},
    EMAIL_STABILITY_CHART_DESCRIPTION: { key: 'EMAIL_STABILITY_CHART_DESCRIPTION', value: 'Failure rate over a period of one year' },
    USAGE_TREND_SENT_COLOR_LABELS:{key:'USAGE_TREND_SENT_COLOR_LABELS',value:'Sent'},
    USAGE_TREND_DELIVERED_COLOR_LABELS:{key:'USAGE_TREND_DELIVERED_COLOR_LABELS',value:'Delivered'},
    EMAIL_PERFORMANCE_OPEN_RATE_COLOR_LABELS:{key:'EMAIL_PERFORMANCE_OPEN_RATE_COLOR_LABELS',value:'Open Rate'},
    EMAIL_PERFORMANCE_CLICK_RATE_COLOR_LABELS: { key: 'EMAIL_PERFORMANCE_CLICK_RATE_COLOR_LABELS', value: 'Click Rate' },
    EMAIL_STABILITY_FAILED_COLOR_LABELS:{key:'EMAIL_STABILITY_FAILED_COLOR_LABELS',value:'Failed'},
    EMAIL_STABILITY_BOUNCED_COLOR_LABELS:{key:'EMAIL_STABILITY_BOUNCED_COLOR_LABELS',value:'Bounced'},
    EMAIL_STABILITY_DATA_ISSUE_COLOR_LABELS:{key:'EMAIL_STABILITY_DATA_ISSUE_COLOR_LABELS',value:'Data Issue'},
    PUBLISHED_TAB_TITLE:{key:'PUBLISHED_TAB_TITLE',value:'Published'},
    TESTING_TAB_TITLE:{key:'TESTING_TAB_TITLE',value:'Testing'},
    EMAIL_DASHBOARD_TITLE:{key:'EMAIL_DASHBOARD_TITLE',value:'Email Dashboard'},
    FUNNEL_SECTION_TITLE:{key:'FUNNEL_SECTION_TITLE',value:'Funnel'},
    FUNNEL_SECTION_SENT_LABEL: {key:'FUNNEL_SECTION_SENT_LABEL',value:'Sent'},
    FUNNEL_SECTION_BOUNCED_LABEL:{key:'FUNNEL_SECTION_BOUNCED_LABEL',value:'Bounced'},
    FUNNEL_SECTION_DELIVERED_LABEL:{key:'FUNNEL_SECTION_DELIVERED_LABEL',value:'Delivered'},
    FUNNEL_SECTION_OPENS_LABEL:{key:'FUNNEL_SECTION_OPENS_LABEL',value:'Opens'},
    FUNNEL_SECTION_CLICKS_LABEL:{key:'FUNNEL_SECTION_CLICKS_LABEL',value:'Clicks'},
    LIST_OF_FAILED_TEMPLATES_TABLE_TITLE:{key:'LIST_OF_FAILED_TEMPLATES_TABLE_TITLE',value:'List of Failed Templates'},
    TOP_TEN_TEMPLATES_PRONE_TO_FAILURE_TABLE_TITLE:{key:'TOP_TEN_TEMPLATES_PRONE_TO_FAILURE_TABLE_TITLE',value:'Top 10 Templates Prone to Failure'},
    FUNNEL_SECTION_TOTAL_CONVERSION_RATE_LABEL: { key: 'FUNNEL_SECTION_TOTAL_CONVERSION_RATE_LABEL', value: 'Total conversion rate' },
    VIEW_LIST_OF_FAILED_TEMPLATES_ACTION:{key:'VIEW_LIST_OF_FAILED_TEMPLATES_ACTION',value:'VIEW'},
    FAILURE_REASONS_SECTION_TITLE: { key: 'FAILURE_REASONS_SECTION_TITLE', value: 'Failure Reasons' },
    FAILURE_STATS_CARD_TITLE:{key:'FAILURE_STATS_CARD_TITLE',value:'Failure Stats'},
    FAILURE_REASONS_BOUNCE_RATE_CARD_TITLE:{key:'FAILURE_REASONS_BOUNCE_RATE_CARD_TITLE',value:'Bounce Rate'},
    FAILURE_REASONS_DATA_INVALID_CARD_TITLE:{key:'FAILURE_REASONS_DATA_INVALID_CARD_TITLE',value:'Data Invalid'},
    FAILURE_REASONS_DOCSTUDIO_CARD_TITLE:{key:'FAILURE_REASONS_DOCSTUDIO_CARD_TITLE',value:'DocStudio'},
    VIEW_TEMPLATES_PRONE_TO_FAILURE_ACTION:{key:'VIEW_TEMPLATES_PRONE_TO_FAILURE_ACTION',value:'View top 10 templates prone to failure'},
    ALL_TEMPLATE_CATEGORY_DROPDOWN_OPTION:{key:'ALL_TEMPLATE_CATEGORY_DROPDOWN_OPTION',value:'All'},
    ALL_TEAMS_DROPDOWN_OPTION:{key:'ALL_TEAMS_DROPDOWN_OPTION',value:'All'},
    TEAM_1_TEMPLATE_CATEGORY_DROPDOWN_OPTION:{key:'TEAM_1_TEMPLATE_CATEGORY_DROPDOWN_OPTION',value:'Team 1'},
    DOCSTUDIO_TEMPLATE_CATEGORY_DROPDOWN_OPTION:{key:'DOCSTUDIO_TEMPLATE_CATEGORY_DROPDOWN_OPTION',value:'DocStudio'},
    PEGA_TEMPLATE_CATEGORY_DROPDOWN_OPTION:{key:'PEGA_TEMPLATE_CATEGORY_DROPDOWN_OPTION',value:'Pega'},
    TEKCLAN_TEMPLATE_CATEGORY_DROPDOWN_OPTION:{key:'TEKCLAN_TEMPLATE_CATEGORY_DROPDOWN_OPTION',value:'TekClan'},
    REQUESTED_TIME_COLUMN_TITLE:{key:'REQUESTED_TIME_COLUMN_TITLE',value:'Request Time'},
    REQUESTED_ID_COLUMN_TITLE:{key:'REQUESTED_ID_COLUMN_TITLE',value:'Request Id'},
    TEMPLATE_COLUMN_TITLE:{key:'TEMPLATE_COLUMN_TITLE',value:'Template'},
    TO_ADDRESS_COLUMN_TITLE:{key:'TO_ADDRESS_COLUMN_TITLE',value:'To Address'},
    FAILURE_REASONS_COLUMN_TITLE:{key:'FAILURE_REASONS_COLUMN_TITLE',value:'Failure Reason'},
    BOUNCE_RATE_DROPDOWN_OPTION:{key:'BOUNCE_RATE_DROPDOWN_OPTION',value:'Bounce Rate'},
    DATA_INVALID_DROPDOWN_OPTION:{key:'DATA_INVALID_DROPDOWN_OPTION',value:'Data Invalid'},
    FAILURE_DESCRIPTION_COLUMN_TITLE:{key:'FAILURE_DESCRIPTION_COLUMN_TITLE',value:'Failure Description'},
    VIEW_FAILURE_DETAILS_ACTION:{key:'VIEW_FAILURE_DETAILS_ACTION',value:'View details'},
    FAILURE_TIME_COLUMN_TITLE:{key:'FAILURE_TIME_COLUMN_TITLE',value:'Failure Time'},
    TEAM_NAME_COLUMN_TITLE:{key:'TEAM_NAME_COLUMN_TITLE',value:'Team Name'},
    DESCRIPTION_TITLE:{key:'DESCRIPTION_TITLE',value:'Description'},
    PAYLOAD_TITLE:{key:'PAYLOAD_TITLE',value:'Payload'},
    SEARCH_BUTTON:{key:'SEARCH_BUTTON',value:'Search'},
    RESET_BUTTON:{key:'RESET_BUTTON',value:'Reset'},
    DRAFT_TAB_TITLE:{key:'DRAFT_TAB_TITLE',value:'Draft'},
    NO_DETAILS_AVAILABLE_LABEL: { key: 'NO_DETAILS_AVAILABLE_LABEL', value: 'No details available.' },
    LANGUAGE_COLUMN_TITLE: { key: 'LANGUAGE_COLUMN_TITLE', value: 'Language' },
}

export const SHORT_MESSAGE_DASHBOARD = {
    USAGE_TREND_CHART_TITLE:{key:'USAGE_TREND_CHART_TITLE',value:'Usage Trend'},
    MESSAGING_STABILITY_CHART_TITLE:{key:'MESSAGING_STABILITY_CHART_TITLE',value:'Messaging Stability'},
    USAGE_TREND_CHART_DESCRIPTION:{key:'USAGE_TREND_CHART_DESCRIPTION',value:'Average number of whatsapp, sms & phone calls initiated'},
    USAGE_TREND_CHART_DESCRIPTION_WHATSAPP_DISABLED:{key:'USAGE_TREND_CHART_DESCRIPTION_WHATSAPP_DISABLED',value:'Average number of sms & phone calls initiated'},
    MESSAGING_STABILITY_CHART_DESCRIPTIO:{key:'MESSAGING_STABILITY_CHART_DESCRIPTIO',value:'Failure rate over a period of one year'},
    USAGE_TREND_CHART_WHATSAPP_COLOR_LABEL: {key:'USAGE_TREND_CHART_WHATSAPP_COLOR_LABEL',value:'WhatsApp'},
    USAGE_TREND_CHART_SMS_COLOR_LABEL:{key:'USAGE_TREND_CHART_SMS_COLOR_LABEL',value:'SMS'},
    USAGE_TREND_CHART_PHONE_CALL_COLOR_LABEL: { key: 'USAGE_TREND_CHART_PHONE_CALL_COLOR_LABEL', value: 'Phone Call' },
    MESSAGING_STABILITY_CHART_WHATSAPP_COLOR_LABEL: {key:'MESSAGING_STABILITY_CHART_WHATSAPP_COLOR_LABEL',value:'WhatsApp'},
    MESSAGING_STABILITY_CHART_SMS_COLOR_LABEL:{key:'MESSAGING_STABILITY_CHART_SMS_COLOR_LABEL',value:'SMS'},
    MESSAGING_STABILITY_CHART_PHONE_CALL_COLOR_LABEL: { key: 'MESSAGING_STABILITY_CHART_PHONE_CALL_COLOR_LABEL', value: 'Phone Call' },
    SHORT_MESSAGE_DASHBOARD_TITLE:{key:'SHORT_MESSAGE_DASHBOARD_TITLE',value:'Short Message Dashboard'},
    PUBLISHED_TAB_TITLE:{key:'PUBLISHED_TAB_TITLE',value:'Published'},
    TESTING_TAB_TITLE: { key: 'TESTING_TAB_TITLE', value: 'Testing' },
    DRAFT_TAB_TITLE: { key: 'DRAFT_TAB_TITLE', value: 'Draft' },
    ALL_TEMPLATE_CATEGORY_DROPDOWN_OPTION: { key: 'ALL_TEMPLATE_CATEGORY_DROPDOWN_OPTION', value: 'All' },
    WHATSAPP_CARD_TITLE: {key:'WHATSAPP_CARD_TITLE',value:'WhatsApp'},
    SMS_CARD_TITLE:{key:'SMS_CARD_TITLE',value:'SMS'},
    PHONE_CALL_CARD_TITLE: { key: 'PHONE_CALL_CARD_TITLE', value: 'Phone Call' },
    WHATSAPP_CARD_SENT_LABEL: {key:'WHATSAPP_CARD_SENT_LABEL',value:'Sent'},
    SMS_CARD_SENT_LABEL: {key:'SMS_CARD_SENT_LABEL',value:'Sent'},
    PHONE_CALLS_CARD_SENT_LABEL: {key:'PHONE_CALLS_CARD_SENT_LABEL',value:'Sent'},
    FAILURE_STATS_SECTION_TITLE: { key: 'FAILURE_STATS_SECTION_TITLE', value: 'Failure Stats' },
    FAILURE_STATS_WHATSAPP_LABEL: {key:'FAILURE_STATS_WHATSAPP_LABEL',value:'WhatsApp'},
    FAILURE_STATS_SMS_LABEL:{key:'FAILURE_STATS_SMS_LABEL',value:'SMS'},
    FAILURE_STATS_PHONE_CALL_LABEL: { key: 'FAILURE_STATS_PHONE_CALL_LABEL', value: 'Phone Call' },
    VIEW_FAILED_WHATSAPP_TEMPLATES_TABLE_ACTION:{key:'VIEW_FAILED_WHATSAPP_TEMPLATES_TABLE_ACTION',value:'VIEW'},
    VIEW_FAILED_SMS_TEMPLATES_TABLE_ACTION:{key:'VIEW_FAILED_SMS_TEMPLATES_TABLE_ACTION',value:'VIEW'},
    VIEW_FAILED_PHONE_CALL_TEMPLATES_TABLE_ACTION:{key:'VIEW_FAILED_PHONE_CALL_TEMPLATES_TABLE_ACTION',value:'VIEW'},
    FAILURE_REASONS_SECTION_TITLE: { key: 'FAILURE_REASONS_SECTION_TITLE', value: 'Failure Reasons' },
    FAILURE_REASONS_WHATSAPP_COULD_NOT_DELIVER_CARD_TITLE:{key:'FAILURE_REASONS_WHATSAPP_COULD_NOT_DELIVER_CARD_TITLE',value:'WhatsApp Could Not Deliver'},
    FAILURE_REASONS_SMS_COULD_NOT_DELIVER_CARD_TITLE:{key:'FAILURE_REASONS_SMS_COULD_NOT_DELIVER_CARD_TITLE',value:'SMS Could Not Deliver'},
    FAILURE_REASONS_PHONE_CALLS_NOT_PICKED_CARD_TITLE:{key:'FAILURE_REASONS_PHONE_CALLS_NOT_PICKED_CARD_TITLE',value:'Call Not Picked'},
    LIST_OF_FAILED_WHATSAPP_TEMPLATES_TABLE_TITLE:{key:'LIST_OF_FAILED_WHATSAPP_TEMPLATES_TABLE_TITLE',value:'List of Failed Templates'},
    LIST_OF_FAILED_SMS_TEMPLATES_TABLE_TITLE:{key:'LIST_OF_FAILED_SMS_TEMPLATES_TABLE_TITLE',value:'List of Failed Templates'},
    LIST_OF_FAILED_PHONE_CALL_TEMPLATES_TABLE_TITLE:{key:'LIST_OF_FAILED_PHONE_CALL_TEMPLATES_TABLE_TITLE',value:'List of Failed Templates'},
}

export const FAILED_SHORT_MESSAGE_TEMPLATES_TABLE = {
    FAILED_TEMPLATES_TABLE_TITLE: { key: 'FAILED_TEMPLATES_TABLE_TITLE', value: 'Failed Transactions' },
    ID_COLUMN_TITLE: { key: 'ID_COLUMN_TITLE', value: 'ID' },
    MESSAGE_TYPE_COLUMN_TITLE:{key:'MESSAGE_TYPE_COLUMN_TITLE',value:'Message Type'},
    STATUS_COLUMN_TITLE:{key:'STATUS_COLUMN_TITLE',value:'Status'},
    DELIVERY_STATUS_COLUMN_TITLE:{key:'DELIVERY_STATUS_COLUMN_TITLE',value:'Delivery Status'},
    FAILURE_DESCRIPTION_COLUMN_TITLE:{key:'FAILURE_DESCRIPTION_COLUMN_TITLE',value:'Failure description'},
    FAILURE_REASON_COLUMN_TITLE:{key:'FAILURE_REASON_COLUMN_TITLE',value:'Failure Reason'},
    TIME_COLUMN_TITLE:{key:'TIME_COLUMN_TITLE',value:'Time'},
    EMPTY_TABLE_DESCRIPTION: { key: 'EMPTY_TABLE_DESCRIPTION', value: 'No Data' },
}

export const EMAIL_AUDIT_DETAILS_MODAL = {
    FAILED_EMAIL_REQUEST_ID_DETAIL_LABEL: { key: 'FAILED_EMAIL_REQUEST_ID_DETAIL_LABEL', value: 'Email Request Id' },
    FAILED_EMAIL_ELAPSED_TIME_LABEL: { key: 'FAILED_EMAIL_ELAPSED_TIME_LABEL', value: 'Elapsed Time' },
    FAILED_EMAIL_TO_ADDRESS_LABEL: { key: 'FAILED_EMAIL_TO_ADDRESS_LABEL', value: 'To address' },
    FAILED_EMAIL_CC_TO_LABEL: { key: 'FAILED_EMAIL_CC_TO_LABEL', value: 'CC' },
    FAILED_EMAIL_BCC_TO_LABEL: { key: 'FAILED_EMAIL_BCC_TO_LABEL', value: 'BCC' },
    REQUEST_EMAIL_AUDIT_TIMELINE_DETAILS_TITLE: { key: 'REQUEST_EMAIL_AUDIT_TIMELINE_DETAILS_TITLE', value: 'Request details' },
    DOWNLOAD_EMAIL_FAILURE_ERROR_MESSAGE_TOOLTIP: { key: 'DOWNLOAD_EMAIL_FAILURE_ERROR_MESSAGE_TOOLTIP', value: 'Download error message' },
    DOWNLOAD_EMAIL_AUDIT_PAYLOAD_BUTTON: { key: 'DOWNLOAD_EMAIL_AUDIT_PAYLOAD_BUTTON', value: 'Download Payload' },
    DOWNLOAD_EMAIL_AUDIT_FILE_BUTTON: { key: 'DOWNLOAD_EMAIL_AUDIT_FILE_BUTTON', value: 'Download file' },
    FAILED_EMAIL_ELAPSED_TIME_MINUTE_LABEL: { key: 'FAILED_EMAIL_ELAPSED_TIME_MINUTE_LABEL', value: 'min' },
    FAILED_EMAIL_ELAPSED_TIME_SECONDS_LABEL: { key: 'FAILED_EMAIL_ELAPSED_TIME_SECONDS_LABEL', value: 'sec' },
}

export const FAILED_TEMPLATES_TABLE = {
    DROPDOWN_CONFIRM_BUTTON: { key: 'DROPDOWN_CONFIRM_BUTTON', value: 'Ok' },
    DROPDOWN_RESET_BUTTON: { key: 'DROPDOWN_RESET_BUTTON', value: 'Reset' },
    NO_DATA_TEXT: { key: 'NO_DATA_TEXT', value: 'No Data' },
}

export const DASHBOARD_ERROR_REPORT = {
  DATA_VALIDATION_ERROR_LABEL: {
    key: 'DATA_VALIDATION_ERROR_LABEL',
    value: 'Data validation errors',
  },
  CHART_VALUE_ERROR_MESSAGE: {
    key: 'CHART_VALUE_ERROR_MESSAGE',
    value: 'these fields should be a number',
  },
  BARCODE39_VALUE_ERROR_MESSAGE: {
    key: 'BARCODE39_VALUE_ERROR_MESSAGE',
    value: 'these fields requires value in uppercase',
  },
  MANDATORY_ERROR_MESSAGE: {
    key: 'MANDATORY_ERROR_MESSAGE',
    value: 'these fields are required',
  },
  MAX_CHARACTERS_ERROR_MESSAGE: {
    key: 'MAX_CHARACTERS_ERROR_MESSAGE',
    value: 'these fields exceeded the maximum characters allowed',
  },
  DATE_FORMAT_ERROR_MESSAGE: {
    key: 'DATE_FORMAT_ERROR_MESSAGE',
    value: 'these fields require value in date format',
  },
  EMPTY_ERROR_MESSAGE: {
    key: 'EMPTY_ERROR_MESSAGE',
    value: 'these fields should not be empty',
  },
};